module.exports = __webpack_public_path__ + "img/43.0623cdd4.jpg";